import { Clients } from './Clients';

export const environment = {
  production: false,
  client: Clients.PACIFIC_REGIONAL,
  appConfigStorageKey: "QP'`0t=Wf_(yB?ni^(*rv0gB].ck$s@z(/SB_PK",
  appConfigName: '@sb_product_creditx_automation',
  appName: 'creditx_automation',
  bankName: 'NEPAL BANK LIMITED',

  baseApiUrl: 'https://mw.pacificregionalbank.com',
  baseApiUrlV2: 'https://mw.pacificregionalbank.com/v2',
  socketUrl: 'https://notifications.pacificregionalbank.com/',

  productName: 'creditx_automation',
  productSlogan:
    ' - CreditX Loan Automation System | Digital Solutions for Your Workstation',
  SBS_GROUP: false,
  pwa: false,
  disableCrgAlpha: false,
  disableCrgLambda: false,
  small_logo_path: 'assets/images/pacific.png',
  large_logo_path: 'assets/images/pacific.png',
};
